export const episodes = [
  {
    id: 66,
    title: '#EP.66 Entrevista com Vinicius Cozzolino',
    image: 'https://i.ytimg.com/vi/iSYBorWRsc8/maxresdefault.jpg',
    duration: '45:14',
    views: '6',
    date: '1 dia atrás',
    link: 'https://www.youtube.com/watch?v=iSYBorWRsc8'
  },
  {
    id: 65,
    title: '#EP.65 Entrevista com Jorge Miranda',
    image: 'https://i.ytimg.com/vi/7TuC2QnZDQA/maxresdefault.jpg',
    duration: '1:05:16',
    views: '5',
    date: '4 dias atrás',
    link: 'https://www.youtube.com/watch?v=7TuC2QnZDQA'
  },
  {
    id: 64,
    title: '#EP.64 Entrevista com Fabiana Marques',
    image: 'https://i.ytimg.com/vi/MOWNY-agM0g/maxresdefault.jpg',
    duration: '58:36',
    views: '21',
    date: '1 mês atrás',
    link: 'https://www.youtube.com/watch?v=MOWNY-agM0g'
  },
  {
    id: 63,
    title: '#EP.63 Entrevista com Professor Rodney',
    image: 'https://i.ytimg.com/vi/WF0UMUgw8EM/maxresdefault.jpg',
    duration: '1:03:05',
    views: '167',
    date: '1 mês atrás',
    link: 'https://www.youtube.com/watch?v=WF0UMUgw8EM'
  },
  {
    id: 62,
    title: '#EP.62 Entrevista com Flávio Poggian',
    image: 'https://i.ytimg.com/vi/PudPvgEVAMk/maxresdefault.jpg',
    duration: '45:39',
    views: '10',
    date: '2 meses atrás',
    link: 'https://www.youtube.com/watch?v=PudPvgEVAMk'
  },
  {
    id: 61,
    title: '#EP.61 Entrevista com Delegado Ruchester Marreiros',
    image: 'https://i.ytimg.com/vi/_E7jdXDwN48/maxresdefault.jpg',
    duration: '50:52',
    views: '15',
    date: '2 meses atrás',
    link: 'https://www.youtube.com/watch?v=_E7jdXDwN48'
  },
  {
    id: 60,
    title: '#EP.60 Entrevista com Delegado Alvaro Lins',
    image: 'https://i.ytimg.com/vi/BzwKvGftlIg/maxresdefault.jpg',
    duration: '1:02:50',
    views: '67',
    date: '2 meses atrás',
    link: 'https://www.youtube.com/watch?v=BzwKvGftlIg'
  },
  {
    id: 59,
    title: '#EP.59 Entrevista com Deputado Estadual Daniel Martins',
    image: 'https://i.ytimg.com/vi/bIeN7VYUS-8/maxresdefault.jpg',
    duration: '42:35',
    views: '9',
    date: '2 meses atrás',
    link: 'https://www.youtube.com/watch?v=bIeN7VYUS-8'
  }
];
